export default __webpack_public_path__ + "static/media/txt_entrance_01.012b386b.svg";